import React from "react";
import { RoomProvider } from "@liveblocks/react";
import TagManager from "react-gtm-module";

import "./App.css";
import "rodal/lib/rodal.css";
import "react-calendar/dist/Calendar.css";
import "antd/dist/antd.css";
import Routes from "./routes";

console.log("process.env.NODE_ENV", process.env.NODE_ENV);
const googleTagManager =
  process.env.NODE_ENV === "development" ? "GTM-WTMKLLX" : "GTM-MDQ4F3F";

function App() {
  const tagManagerArgs = {
    gtmId: googleTagManager,
  };

  TagManager.initialize(tagManagerArgs);

  return (
    <RoomProvider
      id={"example-live-cursors"}
      defaultPresence={() => ({ cursor: null })}
    >
      <Routes />
    </RoomProvider>
  );
}

export default App;
